const state = {
  by: {
    workspace_id: null,
    project_hash: null,
  },
  permissions: [],
};

const getters = {
  getPermissions(state) {
    return state.permissions;
  },

  getBy(state) {
    return state.by;
  },
};

const actions = {
  setPermissions(context, value) {
    if (value) {
      context.commit('setPermissions', {
        by: value.by,
        permissions: value.permissions,
      });
    }
  },
};

const mutations = {
  setPermissions(state, { by, permissions }) {
    state.by = by;
    state.permissions = permissions;
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default module;
